import React, { ReactElement } from 'react';
import type { Route } from 'next';
import dynamic from 'next/dynamic';
import classNames from 'classnames/bind';
import RootLayout from 'layouts/RootLayout';
import { LandingsData, LandingsUrls } from 'sections/Resources/FreightDictionary/data';
import Breadcrumbs from 'components/Breadcrumbs';
import styles from 'pages/freight-dictionary/[title]/Landing.module.scss';

const cn = classNames.bind(styles);

const SectionHeader = dynamic(() => import('sections/Resources/FreightDictionary/landing/SectionHeader'));
const SectionDescription = dynamic(() => import('sections/Resources/FreightDictionary/landing/SectionDescription'));
const SectionRelatedTerms = dynamic(() => import('sections/Resources/FreightDictionary/landing/SectionRelatedTerms'));

export default function Landing(props: any) {
  const isRelatedTermsNotEmpty = Array.isArray(props.relatedTerms) && props.relatedTerms.length > 0;

  return (
    <div className={cn('landing')}>
      <div className={cn('container')}>
        <Breadcrumbs
          mode="light"
          mTop={64}
          links={[
            { title: 'Freight Dictionary', href: '/freight-dictionary' as Route},
            { title: props.breadcrumb, href: '' as Route},
          ]}
        />
      </div>
      <SectionHeader
        titleH1={props.titleH1}
        headParagraphs={props.headParagraphs}
      />
      <SectionDescription
        titleH1={props.titleH1}
        description={props.pageDescription}
        content={props.content}
      />
      {isRelatedTermsNotEmpty
        ?
        <SectionRelatedTerms relatedTerms={props.relatedTerms} />
        :
        null
      }
    </div>
  );
};

export const getServerSideProps = async (context: any) => {
  const url = context.params.title;

  const isValidUrl = LandingsUrls.some((item: any) => item.url === url);

  if (!isValidUrl) {
    return {
      redirect: {
        destination: '/freight-dictionary',
        statusCode: 301,
      }
    }
  }

  const meta: any = {
    title: LandingsData[url].meta.title,
    description: LandingsData[url].meta.description,
    keywords: LandingsData[url].meta.keywords,
    path: `/freight-dictionary/${url}`
  };

  const pageData: any = {
    titleH1: LandingsData[url].data.titleH1,
    pageDescription: LandingsData[url].data.description || null,
    content: LandingsData[url].data.content || null,
    headParagraphs: LandingsData[url].data.headParagraphs || null,
    breadcrumb: LandingsData[url].data.breadcrumb || null,
    relatedTerms: LandingsData[url].data.relatedTerms || null,
  };

  return {
    props: {
      LandingsData,
      ...meta,
      ...pageData,
    }
  }
};

Landing.getLayout = function getLayout(page: ReactElement) {
  return <RootLayout>{page}</RootLayout>;
};
